import Vue from "vue";

export default () => {
  Vue.filter("valueFormatCurrencyCode", (element, currency, codeCurrency) => {
    return element.amount
      ? `${element.currency_symbol} ${new Intl.NumberFormat().format(
          element.amount
        )} ${element.currency_code} ${
          element.currency_code !== codeCurrency
            ? `→ ${currency} ${new Intl.NumberFormat().format(
                element.conversion_amount
              )} ${codeCurrency}`
            : ""
        }`
      : "";
  });
};
